import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';

var isTargetInsideContainer = function isTargetInsideContainer(target, container) {
  return target && container && (target.parentElement === container || isTargetInsideContainer(target.parentElement, container));
};

var formatSvgBase64Src = function formatSvgBase64Src(svgString) {
  if (typeof btoa !== "undefined") {
    return "data:image/svg+xml;base64,".concat(btoa(svgString));
  } // @ts-ignore


  if (typeof global !== "undefined" && typeof Buffer !== "undefined") {
    // @ts-ignore
    return "data:image/svg+xml;base64,".concat(Buffer.from(svgString, "binary").toString("base64"));
  }
};

function cleanupClassNames(classNames) {
  var result = classNames.filter(function (elm) {
    return !!elm;
  }).join(" ");
  return result ? result : undefined;
}

function cleanupClassObject(classObject) {
  return Object.entries(classObject).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        cssClass = _ref2[0],
        isActive = _ref2[1];

    return isActive ? "".concat(acc).concat(cssClass, " ") : acc;
  }, "");
}

var time = Date.now();

var getTime = function getTime() {
  time = Math.max(time + 1, Date.now());
  return time;
};

var uniqueId = function uniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return prefix + getTime().toString(36);
};

export { cleanupClassNames, cleanupClassObject, formatSvgBase64Src, isTargetInsideContainer, uniqueId };
